import { User } from "@/services/api/sdk";
import { ApiObject, RudderAnalytics } from "@rudderstack/analytics-js";

const rudderAnalytics = new RudderAnalytics();

const isTrackingEnabled: boolean = !!import.meta.env.VITE_RUDDERSTACK_WRITE_KEY;

if (isTrackingEnabled) {
    rudderAnalytics.load(import.meta.env.VITE_RUDDERSTACK_WRITE_KEY, import.meta.env.VITE_RUDDERSTACK_DATA_PLANE_URL, {});
}

function safeAnalyticsCall(fn: () => void) {
    if (!isTrackingEnabled) {
        return;
    }
    try {
        fn();
    } catch (e) {
        console.error(e);
    }
}

export function trackIdentify({ user, tenantId }: { user: User; tenantId: number; }) {
    safeAnalyticsCall(() => {
        rudderAnalytics.identify(
            user.id?.toString() ?? "",
            {
                tenantId: tenantId,
                email: user?.email,
                firstName: user?.firstName,
                lastName: user?.lastName,
                role: user.role,
            },
            () => { }
        );
    });
}

export function trackEvent(eventName: string, properties?: ApiObject) {
    safeAnalyticsCall(() => {
        rudderAnalytics.track(eventName, properties, () => { });
    });
}

export function trackPageview({ path, name, properties }: { path: string; name: string; properties: ApiObject; }) {
    safeAnalyticsCall(() => {
        rudderAnalytics.page(
            path,
            name,
            properties,
            () => { }
        );
    });
}
